export default __webpack_public_path__ + "static/media/accounts-01.a04ba4e5.jpg";